import { Box, Dialog, IconButton, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const ViewerDialog = styled(Dialog)(({ theme }) => ({
  '.MuiDialog-paper': {
    backgroundColor: theme.palette.common.black,
    margin: 0,
    maxWidth: '100%',
    maxHeight: '100%',
    width: '100%',
    height: '100%',
    borderRadius: 0,
  },
}));

export const TopBar = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1, 1, 1, 2),
  background: `linear-gradient(to bottom, ${alpha(theme.palette.common.black, 0.6)}, transparent)`,
  zIndex: 10,
  color: theme.palette.common.white,
}));

export const TopBarInfo = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  margin: theme.spacing(0, 1),
}));

export const FileName = styled(Box)({
  fontSize: 14,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const ImageCounter = styled(Box)({
  fontSize: 12,
  opacity: 0.8,
});

export const BottomBar = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(2),
  background: `linear-gradient(to top, ${alpha(theme.palette.common.black, 0.6)}, transparent)`,
  zIndex: 10,
}));

export const ImageContainer = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
});

export const NavButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 10,
  color: alpha(theme.palette.common.white, 0.8),
  backgroundColor: alpha(theme.palette.common.black, 0.3),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.5),
  },
}));
